var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#337a10",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 22",
    id: "Layer_22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.47,15.27a7.91,7.91,0,0,0,.25-2.06,8,8,0,0,0-8-8h-.09A8,8,0,0,0,16,7.58a8.2,8.2,0,0,0-5.71-2.26,8.16,8.16,0,0,0-7.85,10,1,1,0,0,0-.43.83,1,1,0,0,0,1,1h.05a8.31,8.31,0,0,0,1.58,2.18l.43.39a1.07,1.07,0,0,0,.14.16l10.22,10a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.3l10-10.23a1.06,1.06,0,0,0,.24-.39l.32-.31a7.94,7.94,0,0,0,1.32-1.8H29a1,1,0,0,0,1-1A1,1,0,0,0,29.47,15.27ZM6,9.18a6.15,6.15,0,0,1,8.7-.09,5.38,5.38,0,0,1,.49.54,1.22,1.22,0,0,0,.15.17,1.06,1.06,0,0,0,1.45-.06l.11-.13a3.55,3.55,0,0,1,.47-.55,6,6,0,0,1,4.27-1.82h.06a6,6,0,0,1,5.75,7.87L18.26,15h0a1,1,0,0,0-.92.61L17,14.28a1,1,0,0,0-.61-.67,1,1,0,0,0-.91.11l-1.26.85-1.4-4a1,1,0,0,0-.8-.66,1,1,0,0,0-1,.4L7.57,15l-3.12.08A6.13,6.13,0,0,1,6,9.18Zm20,8.35a4.43,4.43,0,0,1-.55.49,1,1,0,0,0-.39.6l-8.93,9.12L6.84,18.65a1,1,0,0,0-.27-.33,4.23,4.23,0,0,1-.51-.44,5.65,5.65,0,0,1-.67-.81L8.11,17a1,1,0,0,0,.78-.41L11.52,13l1.2,3.45a1,1,0,0,0,.63.62,1,1,0,0,0,.88-.12l1.18-.8.79,2.9a1,1,0,0,0,.92.74h.05a1,1,0,0,0,.93-.64L18.93,17l7.41.09A4.58,4.58,0,0,1,26,17.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.036560c71a98a6b83155398c6cb6d5d3.svg";
export { ForwardRef as ReactComponent };